import { render, staticRenderFns } from "./sendList.vue?vue&type=template&id=6e03a12e&scoped=true&"
import script from "./sendList.vue?vue&type=script&lang=js&"
export * from "./sendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e03a12e",
  null
  
)

export default component.exports